import React from 'react';
import PropTypes from 'prop-types';
import { CardContainer, CardHeader, CardTitle, CardIconWrapper, CardContent, CardMainValue, CardTrend } from './components/CardValueStyles';
import { getTrendIcon, formatValue } from './utils/cardValueHelpers';
import Icon from '../../atoms/Icon';

const CardValue = ({ 
  title, 
  value, 
  icon, 
  trend, 
  trendValue, 
  prefix, 
  suffix 
}) => {
  return (
    <CardContainer>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {icon && (
          <CardIconWrapper>
            <Icon className={`fas fa-${icon}`} size="md" color="inherit" />
          </CardIconWrapper>
        )}
      </CardHeader>
      <CardContent>
        <CardMainValue>{formatValue(value, prefix, suffix)}</CardMainValue>
        {trend && (
          <CardTrend trend={trend}>
            <Icon className={`fas fa-${getTrendIcon(trend)}`} size="xs" color="inherit" />
            <span>{trendValue}</span>
          </CardTrend>
        )}
      </CardContent>
    </CardContainer>
  );
};

CardValue.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.string,
  trend: PropTypes.oneOf(['up', 'down', 'neutral']),
  trendValue: PropTypes.string,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
};

CardValue.defaultProps = {
  value: undefined,
  icon: undefined,
  trend: undefined,
  trendValue: undefined,
  prefix: '',
  suffix: '',
};

export default CardValue;



// WEBPACK FOOTER //
// ./src/design-system/molecules/CardValue/CardValue.jsx